import React, { FC, useMemo } from 'react';
import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import { Checkbox, CheckboxGroup } from 'wix-ui-tpa';

import { IWidgetProps } from '../../Widget';
import { ProductFacet } from '../ProductFacet';
import { st, classes } from './ProductFacetsCollections.st.css';
import { getVisibleCollections } from '../../../../../../lib/productFacets';

interface ProductFacetsCollectionsProps {
  collections: IWidgetProps['productFacets']['collections'];
  selectedCollections?: IWidgetProps['productFacets']['filter']['collections'];
  onFacetsFilterChange: IWidgetProps['onProductFacetsFilterChange'];
}

export const ProductFacetsCollections: FC<ProductFacetsCollectionsProps> = ({
  collections,
  selectedCollections = [],
  onFacetsFilterChange,
}) => {
  const { isMobile } = useEnvironment();
  const { t } = useTranslation();

  const visibleCollections = useMemo(() => {
    return getVisibleCollections(collections, selectedCollections);
  }, [collections, selectedCollections]);

  const renderLabel = (title: string, count: number) => {
    return (
      <>
        {title} <span className={classes.count}>({count})</span>
      </>
    );
  };

  return (
    <ProductFacet title={t('searchResults.facets.collectionTitle')}>
      <CheckboxGroup className={st(classes.root, { mobileView: isMobile })}>
        {visibleCollections.map(({ value, count }) => (
          <Checkbox
            data-hook={`facet-collection-item-${value}`}
            className={classes.checkbox}
            label={renderLabel(value, count)}
            checked={selectedCollections.includes(value)}
            key={value}
            onChange={({ checked }) => {
              onFacetsFilterChange({
                collections: checked
                  ? [...selectedCollections, value]
                  : [...selectedCollections.filter((v) => v !== value)],
              });
            }}
          />
        ))}
      </CheckboxGroup>
    </ProductFacet>
  );
};
